module.exports = __webpack_public_path__ + "2a30181ee41cfa6624c067186f26243c.svg";